import CancelledCommandException from "../Core/Scheduler/CancelledCommandException"; // max retry loading before changing the status to definitiveError

var MAX_RETRY = 4;
export default function handlingError(err, node, layer, targetLevel, view) {
  if (err instanceof CancelledCommandException) {
    node.layerUpdateState[layer.id].success();
  } else if (err instanceof SyntaxError) {
    node.layerUpdateState[layer.id].failure(0, true);
  } else {
    var definitiveError = node.layerUpdateState[layer.id].errorCount > MAX_RETRY;
    node.layerUpdateState[layer.id].failure(Date.now(), definitiveError, {
      targetLevel: targetLevel
    });

    if (!definitiveError) {
      window.setTimeout(function () {
        view.notifyChange(node, false);
      }, node.layerUpdateState[layer.id].secondsUntilNextTry() * 1000);
    }
  }
}